export default __webpack_public_path__ + "static/media/moderation.233ad13f.svg";